import { useMarkContactForDeletionMutation } from '~/graphql/types';
import useCurrentAccount from '../useCurrentAccount';
import markedForDeletionContactList from '~/components/page/Contacts/util/markedForDeletionContactList';
import useTrackEvent from '../useTrackEvent';

type DeleteContactResult = {
  success: boolean;
  error?: Error;
};

const useDeleteContact = () => {
  const account = useCurrentAccount();
  const trackEvent = useTrackEvent();
  const [markContactForDeletion, { loading }] =
    useMarkContactForDeletionMutation({});

  const deleteContact = async (
    contactId: string,
  ): Promise<DeleteContactResult> => {
    const mutationResult = await markContactForDeletion({
      variables: {
        accountId: account.id,
        id: contactId,
      },
    });

    if (
      !mutationResult ||
      !mutationResult.data ||
      mutationResult.data.markContactForDeletion.success !== true
    ) {
      return {
        success: false,
        error: new Error('Failed to delete contact'),
      };
    }

    markedForDeletionContactList.writeMarkedForDeletionContact(contactId);

    trackEvent({
      eventName: 'contact_deleted',
      parameters: { contact_id: contactId, account_id: account.id },
    });

    return { success: true };
  };

  return {
    deleteContact,
    loading,
  };
};

export default useDeleteContact;
